import { render, staticRenderFns } from "./ProductBlockConstructor.vue?vue&type=template&id=f4f81782"
import script from "./ProductBlockConstructor.vue?vue&type=script&lang=js"
export * from "./ProductBlockConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports